import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const addNewBanqueApi = async(banqueData) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const objectData = {
            label: banqueData.label,
            value: banqueData.value
        }

        const res = await axios.post(`${API_URL}/api/banks/addNew/${id}/${iv}`, objectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const updateBanqueApi = async(banqueData, banqueId) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const objectData = {
            label: banqueData.label,
            value: banqueData.value
        }

        const res = await axios.put(`${API_URL}/api/banks/update/${id}/${iv}/${banqueId}`, objectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllBanquesApi = async (label = "") => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/banks/getAll/${id}/${iv}?label=${label}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const deleteBanqueApi = async(banqueId) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.delete(`${API_URL}/api/banks/delete/${id}/${iv}/${banqueId}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}
